

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';

export class ConfirmPaymentRequestParams extends BaseEntity
{   
    public PrivateID: string; 
    public IsSaveCardNumberAsDefault: boolean; 
	
}



